import { Card, Flex } from "antd";

import { SalesPipelineProjects } from "sales/components";
import { PipelineByProjectsStage } from "sales/components/pipeline-by-projects-stage/PipelineByProjectsStage";
import { PipelineDetails } from "sales/components/pipeline-details/PipelineDetails";
import {
  ISalesPipelineProjects,
  IPipelineDetails,
} from "sales/models";
import { IProjectByStage } from "projects/models";
import variables from "../../../../../_variables.scss";

type Props = {
  loading?: boolean;
  salesPipelineProjects?: ISalesPipelineProjects;
  pipelineDetails?: IPipelineDetails[];
  pipelineByProjectStages?: IProjectByStage[];
};

export const SalesRepDashboardSalesPipelineCard = ({
  loading,
  salesPipelineProjects,
  pipelineDetails,
  pipelineByProjectStages,
}: Props) => {
  return (
    <Card
      loading={loading}
      bordered={false}
      data-testid='salesRepDashboardSalesPipelineCard'
    >
      <Flex vertical gap={variables.gap}>
        <h1>My Sales Pipeline</h1>
        <SalesPipelineProjects salesPipelineProjects={salesPipelineProjects ?? { totalProjects: 0, totalProjectsValue: 0, totalProjectsClosingInThirtyDays: 0 }} />
        <PipelineDetails pipelineDetails={pipelineDetails ?? []} />
        <PipelineByProjectsStage pipelineByProjectStages={pipelineByProjectStages ?? []} height={variables.defaultComponentHeight} />
      </Flex>
    </Card>
  );
};
